import { groupBy, sortBy } from "lodash-es";
import {
  acceptHotItemStore,
  defineItemStore
} from "@editor/items/itemStore.store";

import type { IndicatorItem } from "./IndicatorItem";

const itemStructure: IndicatorItem = {
  type: "indicator",
  id: 0,
  uid: "indicator_0",

  targetId: -1, // required!
  title: "Indikator",
  description: "",

  docs: {},
  createdAt: -1,
  order: -1
};

export const useIndicatorStore = defineItemStore(
  "model/indicators",
  itemStructure,
  {
    getters: {
      byTarget(state): { [targetId: number]: IndicatorItem[] } {
        return groupBy(state.items, "targetId");
      }
    },

    events: {
      async afterDelete(indicator, indicatorStore) {
        indicatorStore.reorderInTarget(indicator.targetId);
      }
    },

    actions: {
      /**
       * Reorders all the indicators of one target.
       * @targetId Id of the target whose indicators shall be reordered
       */
      reorderInTarget(targetId: number) {
        const othersInList = Object.values(this.items).filter(
          (i) => i.targetId === targetId
        );
        const ordered = sortBy(othersInList, "order");
        for (let i = 0; i < ordered.length; i++) {
          this.items[ordered[i].id].order = i;
        }
      }
    }
  }
);

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHotItemStore(useIndicatorStore, import.meta.hot)
  );
}
